import React, { Component } from 'react';
import SearchProductForm from '../../../components/Admin/Product/SearchProduct'
import CommonGrid from '../../../components/common/commongrid'
import {
    Card, CardBody, Pagination
} from 'reactstrap';
import PageSpinner from "../../../components/PageSpinner";
import EditProductForm from '../../../components/Admin/Product/EditProduct'
const colHeader = [
    { dataField: 'ID', text: 'Sr No' },
    { dataField: 'PRODUCT', text: 'Name' },
    { dataField: 'GROUP', text: 'Group' },
    { dataField: 'INTERFACE', text: 'IsInterface' }
];
var dataColumns = colHeader.map(function (d) { return { dataField: d.dataField, text: d.text, sort: true } });

class SearchProductPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: false,
            addrow : false
        };
    }
    setData = (data) =>  {
        this.setState({...this.state, data})
    }
    loading = (isLoading) => {
        this.setState({...this.state, isLoading})
    }
    Add = ( toggle)=> {
        this.setState({ ...this.state, addrow:toggle });
    }
    render(){
        return (
            <>
                <SearchProductForm SetData={this.setData} loading={this.loading} Add={this.Add}/>
                {(this.state.isLoading == true) && (< PageSpinner />)}
                <Card className="w-100">
                <CardBody>
                {(this.state.isLoading == false ) && (
                    <CommonGrid 
                    data={this.state.data} 
                    OrderColumns={dataColumns} 
                    />
                )}

                </CardBody>
                </Card>
                {(this.state.addrow ) && <EditProductForm  Add={this.Add} isOpen={this.state.addrow} />}
            </>
        )
    }
}


export default SearchProductPage